import { MerchantTabs, merchantTabValueMapping } from "consts/merchants";
import { getSearchParameterFromUrl } from "util/support";
import {
    bootstrapEntityFactory,
    resourceSliceFactory,
    withBootstrapData,
    withEntityFactory
} from "infrastructure/store/state";
import type { MerchantGroup, MerchantsState } from "./types";

const state: MerchantsState = {
    merchants: resourceSliceFactory(),
    activeTab: merchantTabValueMapping.get(getSearchParameterFromUrl({
        name: 'activeTab',
        fallbackValue: '1'
    })) ?? MerchantTabs.Merchants,
    [MerchantTabs.Merchants]: resourceSliceFactory({
        ...withBootstrapData({
            merchantGroups: bootstrapEntityFactory(Array.of<MerchantGroup>())
        }),
        ...withEntityFactory()
    }),
    [MerchantTabs.MerchantUsers]: resourceSliceFactory(),
    merchantUsers: resourceSliceFactory(),
    ledgers: resourceSliceFactory()
};

export const sliceToken = 'merchants';

export default state;
